<template>
  <div>
    <div class="search-box min">
      <div class="input-item">
        <span class="label">产品配置方式</span>
        <RadioGroup v-model="type" @on-change="updateType">
          <Radio label="1">列表</Radio>
          <Radio label="2">
            <span>卡片</span>
            <Poptip trigger="hover" placement="right-start" transfer>
              <template #content>
                <img class="example-img" src="@static/images/operate/productHot1.png" v-if="$units.isOkBao()" />
                <img class="example-img" src="@static/images/operate/productHot2.png" v-else />
              </template>
              <Icon type="md-help-circle" color="#A8ADB7"/>
            </Poptip>
          </Radio>
          
        </RadioGroup>
      </div>
    </div>
    <keep-alive>
      <hotProductConfig1 v-if="type == '1'" />
      <hotProductConfig2 v-if="type == '2'" />
    </keep-alive>
  </div>
</template>

<script>
import hotProductConfig1 from './hotProductConfig1';
import hotProductConfig2 from './hotProductConfig2';
export default {
  name: 'hotProductConfig',
  components: {
    hotProductConfig1,
    hotProductConfig2
  },
  data() {
    return {
      type: '1'
    };
  },
  created() {
    this.getShowType();
  },
  methods: {
    getShowType(){
      this.$http({
        url: '/buz/exhibitionPicConfigType/getShowType',
        type: 'GET',
        data: {
        }
      }).then(res => {
        this.type = res.data;
      }).finally(()=>{
        this.listLoading = false;
      });
    },
    // 更新type
    updateType() {
      this.$http({
        url: '/buz/exhibitionPicConfigType/changeShowType',
        type: 'POST',
        data: {
          hotShowType: this.type
        }
      }).then(res => {
        this.getShowType();
        this.$notice.success('修改产品配置方式成功');
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.ivu-poptip {
  vertical-align: -1px;
  .example-img {
    width: 100%;
  }
}
</style>
